<pbc-sorter [config]="KonstantesSorterConfig" [sorter]="konstantes.sorter$ | async" (sorterChange)="konstantes.sorter$.next($event)"></pbc-sorter>
